import React from "react";
import { Container, ErrorMessage, InputContainer, LabelContainer } from "./style";

export const Input = ({ label, placeholder, type, name }) => {
  return (
    <Container>
      <LabelContainer htmlFor="">{label}</LabelContainer>
      <InputContainer placeholder={placeholder} {...name.inputProps} />
      {name.error && <ErrorMessage>{name.error}</ErrorMessage>}
    </Container>
  );
};
